'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import LobbyPageSkeleton from '@/components/skeletons/LobbyPageSkeleton';
import { useNavigation } from '@/hooks/navigation';
import { useCommonStore, useModalsStore } from '@/store';

export default function SignUp() {
  const { navigate } = useNavigation();
  const searchParams = useSearchParams().toString();

  const open = useModalsStore.use.open();
  const pendingUser = useCommonStore.use.pendingUser();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  useEffect(() => {
    if (pendingUser) return;
    if (isAuthenticated) return navigate('/');

    navigate(
      `/${searchParams ? `?${searchParams}&modal=registration` : '?modal=registration'}`,
      true
    );
  }, [pendingUser, isAuthenticated, navigate, open, searchParams]);

  return <LobbyPageSkeleton withTitle />;
}
